"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cmsDataIncludingLinkData = exports.cmsdataIncludingDateRange = exports.cmsdataLibraryItemNested = exports.cmsdata = exports.FailureData = void 0;
exports.FailureData = {
    field_pagegroup: 'KS_Homepage',
    id: 1,
    bundle: 'homepage',
    page_heading: '???',
    meta_title: 'Hast du schon einmal unsere Suche ausprobiert? | I`m walking',
    meta_description: '404',
    canonical: 'https://www.imwalking.de/',
    paragraph: [
        {
            id: 30,
            type: 'image_simple',
            image_default: {
                url: 'https://www.imwalking.de/INTERSHOP/static/WFS/EmpirieCom-ImwalkingDE-Site/-/EmpirieCom-ImwalkingDE/de_DE/Content/Fehlerseite/Grafik_Text_V2.jpg',
                data: {
                    alt: '404 Image',
                    title: '404 Image',
                },
            },
            field_link: 'https://www.imwalking.de/',
            field_link_title: 'Startpage',
            field_tracking: '404',
        },
    ],
};
exports.cmsdata = {
    webapp_version: 1,
    menus: {
        'baur-service': [
            {
                title: 'Allgemeine Kundenbetreueung',
                is_external: false,
                internal_path: 'node/13',
                alias: '/baurde/baur-service/allgemeine-kundenbetreueung',
            },
        ],
        'baur-shop': [
            {
                title: 'Damen',
                is_external: false,
                internal_path: 'node/12',
                alias: '/baurde/baur-shop/damen',
            },
            {
                title: 'test-juri',
                is_external: false,
                internal_path: 'node/17',
                alias: '/baurde/baur-shop/test-juri',
            },
        ],
        footer: [
            {
                title: 'Contact',
                is_external: false,
                internal_path: 'contact',
                alias: '/contact',
            },
        ],
        'iaw-service': [
            {
                title: 'Häufige Fragen (FAQ)',
                is_external: false,
                internal_path: 'node/11',
                alias: '/imwalkingde/iaw-service/haeufige-fragen-faq',
            },
            {
                title: 'test-stegmann2',
                is_external: false,
                internal_path: 'node/16',
                alias: '/imwalkingde/iaw-service/test-stegmann2',
            },
        ],
        'iaw-shop': [
            {
                title: 'Damen',
                is_external: false,
                internal_path: 'node/10',
                alias: '/imwalkingde/iaw-shop/damen',
            },
        ],
        main: [
            {
                title: 'Home',
                is_external: false,
                internal_path: '',
                alias: '/',
            },
        ],
    },
    nid: 7,
    langcode: 'de',
    type: 'imwalkingde',
    status: true,
    title: 'Homepage',
    promote: false,
    sticky: false,
    moderation_state: 'published',
    path: [
        {
            alias: '/emma-cms',
            pid: 8,
            langcode: 'de',
            lang: 'de',
            field_name: 'path',
        },
    ],
    field_pagegroup: 'KS_Homepage',
    paragraph: [
        {
            field_tracking: 'tracking',
            field_text: 'Headline Text',
            field_level: 3,
            field_text_subheadline: 'Subheadline',
            field_styling_level: 2,
            field_margin_variant: 'none',
            type: 'headline',
        },
        {
            id: 70,
            type: 'placeholder',
            field_placeholder_variants: 'newsletter-agnitas',
        },
        {
            id: 594,
            langcode: 'de',
            type: 'dynamic_yield',
            status: true,
            parent_field_name: 'field_paragraph_iaw',
            field_custom_id: 'home_banner',
            field_margin: '4rem 0 0 0',
            field_type: 'dynamicyield',
            data: {
                target_id: '594',
                target_revision_id: '25045',
            },
            field_name: 'field_paragraph_iaw',
        },
        {
            id: 1,
            langcode: 'de',
            type: 'slider',
            status: true,
            parent_field_name: 'field_paragraphs',
            field_autoplay: true,
            field_infinite: true,
            paragraph: [
                {
                    id: 3,
                    langcode: 'de',
                    type: 'image_simple',
                    status: true,
                    parent_field_name: 'field_group',
                    field_lazyload: false,
                    field_link: 'https://www.imwalking.de/damenschuhe/sandalen/#highlight=25901709,74801623&lmPromo=la,2,hk,Startseite,fl,Startseite_Flagship1',
                    field_persist_target: false,
                    field_tracking: 'la,2,hk,Startseite,fl,Startseite_Flagship1',
                    field_type: 'media',
                    image_default: {
                        fid: 106,
                        langcode: 'en',
                        filename: 'stage_kw19_sandalensandaletten_button_v2.jpg',
                        uri: 'cloud-storage-production://2020-06/stage_kw19_sandalensandaletten_button_v2.jpg',
                        url: '{STORYBOOK}/1140x450.png',
                        filemime: 'image/jpeg',
                        filesize: 117288,
                        status: true,
                        data: {
                            target_id: '106',
                            alt: 'Sandalen & Sandaletten bei I&apos;m walking',
                            title: 'Sandalen & Sandaletten bei I&apos;m walking',
                            width: '1140',
                            height: '450',
                        },
                        lang: 'de',
                        field_name: 'field_image_default',
                    },
                    image_mobile: {
                        fid: 107,
                        langcode: 'en',
                        filename: 'stage_kw19_sandalensandaletten_mobile_v2.jpg',
                        uri: 'cloud-storage-production://2020-06/stage_kw19_sandalensandaletten_mobile_v2.jpg',
                        url: '{STORYBOOK}/1140x450.png',
                        filemime: 'image/jpeg',
                        filesize: 64127,
                        status: true,
                        data: {
                            target_id: '107',
                            alt: 'Sandalen & Sandaletten bei I&apos;m walking',
                            title: 'Sandalen & Sandaletten bei I&apos;m walking',
                            width: '570',
                            height: '225',
                        },
                        lang: 'de',
                        field_name: 'field_image_mobile',
                    },
                    data: {
                        target_id: '3',
                        target_revision_id: '4854',
                    },
                    field_name: 'field_group',
                },
                {
                    id: 5,
                    langcode: 'de',
                    type: 'image_simple',
                    status: true,
                    parent_field_name: 'field_group',
                    field_lazyload: false,
                    field_link: 'https://www.imwalking.de/damenschuhe/sneaker/#highlight=22223039&lmPromo=la,2,hk,Startseite,fl,Startseite_Flagship2',
                    field_tracking: 'la,2,hk,Startseite,fl,Startseite_Flagship1',
                    field_type: 'media',
                    image_default: {
                        fid: 86,
                        langcode: 'en',
                        filename: 'stage_kw19_sommersneaker_button.jpg',
                        uri: 'cloud-storage-production://2020-05/stage_kw19_sommersneaker_button.jpg',
                        url: '{STORYBOOK}/1140x450.png',
                        filemime: 'image/jpeg',
                        filesize: 120271,
                        status: true,
                        data: {
                            target_id: '86',
                            alt: 'sommerliche Sneaker bei I&apos;m walking',
                            title: 'sommerliche Sneaker bei I&apos;m walking',
                            width: '1140',
                            height: '450',
                        },
                        lang: 'de',
                        field_name: 'field_image_default',
                    },
                    image_mobile: {
                        fid: 87,
                        langcode: 'en',
                        filename: 'stage_kw19_sommersneaker_mobile.jpg',
                        uri: 'cloud-storage-production://2020-05/stage_kw19_sommersneaker_mobile.jpg',
                        url: '{STORYBOOK}/1140x450.png',
                        filemime: 'image/jpeg',
                        filesize: 26275,
                        status: true,
                        data: {
                            target_id: '87',
                            alt: 'sommerliche Sneaker bei I&apos;m walking',
                            title: 'sommerliche Sneaker bei I&apos;m walking',
                            width: '570',
                            height: '225',
                        },
                        lang: 'de',
                        field_name: 'field_image_mobile',
                    },
                    data: {
                        target_id: '5',
                        target_revision_id: '4855',
                    },
                    field_name: 'field_group',
                },
                {
                    id: 6,
                    langcode: 'de',
                    type: 'image_simple',
                    status: true,
                    parent_field_name: 'field_group',
                    field_display_variant: 'default',
                    field_lazyload: false,
                    field_link: 'https://www.imwalking.de/fashion/#highlight=81529317,55682763,20152337,75754504&lmPromo=la,2,hk,Startseite,fl,Startseite_Flagship3',
                    field_persist_target: false,
                    field_tracking: 'la,2,hk,Startseite,fl,Startseite_Flagship3',
                    field_type: 'media',
                    image_default: {
                        fid: 88,
                        langcode: 'en',
                        filename: 'stage_kw10_fashion_v2_button.jpg',
                        uri: 'cloud-storage-production://2020-05/stage_kw10_fashion_v2_button.jpg',
                        url: '{STORYBOOK}/1140x450.png',
                        filemime: 'image/jpeg',
                        filesize: 119741,
                        status: true,
                        data: {
                            target_id: '88',
                            alt: 'Fashion News bei I&apos;m walking',
                            title: 'Fashion News bei I&apos;m walking',
                            width: '1140',
                            height: '450',
                        },
                        lang: 'de',
                        field_name: 'field_image_default',
                    },
                    image_mobile: {
                        fid: 89,
                        langcode: 'en',
                        filename: 'stage_kw10_fashion_v2_ohne_mobile.jpg',
                        uri: 'cloud-storage-production://2020-05/stage_kw10_fashion_v2_ohne_mobile.jpg',
                        url: '{STORYBOOK}/1140x450.png',
                        filemime: 'image/jpeg',
                        filesize: 62945,
                        status: true,
                        data: {
                            target_id: '89',
                            alt: 'Fashion News bei I&apos;m walking',
                            title: 'Fashion News bei I&apos;m walking',
                            width: '570',
                            height: '225',
                        },
                        lang: 'de',
                        field_name: 'field_image_mobile',
                    },
                    data: {
                        target_id: '6',
                        target_revision_id: '4856',
                    },
                    field_name: 'field_group',
                },
            ],
            field_margin: '0 0 0 0',
            field_type: 'slider',
            field_valid_from: '2020-04-01T10:03:41+02:00',
            data: {
                target_id: '1',
                target_revision_id: '4857',
            },
            field_name: 'field_paragraphs',
        },
        {
            id: 86,
            langcode: 'de',
            type: 'headline',
            status: true,
            parent_field_name: 'field_paragraph_iaw',
            field_element_type: 'div',
            field_level: 3,
            field_margin_variant: 'medium',
            field_text: 'Zeit zum Lieblinge shoppen',
            field_text_align: 'center',
            field_type: 'headline',
            field_variation: 1,
            data: {
                target_id: '86',
                target_revision_id: '2449',
            },
            field_name: 'field_paragraph_iaw',
        },
        {
            id: 83,
            langcode: 'de',
            type: 'imagegroup',
            status: true,
            parent_field_name: 'field_paragraph_iaw',
            field_cells_per_row: 2,
            field_col_gap: '10px',
            paragraph: [
                {
                    id: 82,
                    langcode: 'de',
                    type: 'image_simple',
                    status: true,
                    parent_field_name: 'field_group',
                    field_link: 'https://www.imwalking.de/marken/remonte/#highlight=46833916&lmPromo=la,2,hk,Startseite,fl,Startseite_Markenteaser_Remonte',
                    field_tracking: 'lmPromo=la,2,hk,Startseite,fl,Startseite_Markenteaser_Remonte',
                    field_type: 'media',
                    image_default: {
                        fid: 52,
                        langcode: 'de',
                        filename: 'hp_topshop_marke_remonte_kw36_2019.jpg',
                        uri: 'public://2019-09/hp_topshop_marke_remonte_kw36_2019.jpg',
                        url: '{STORYBOOK}/565x364.png',
                        filemime: 'image/jpeg',
                        filesize: 74278,
                        status: true,
                        data: {
                            target_id: '52',
                            alt: "Remonte - Lieblingsschuhe bei I'm walking shoppen",
                            title: "Remonte - Lieblingsschuhe bei I'm walking shoppen",
                            width: '564',
                            height: '364',
                        },
                        lang: 'de',
                        field_name: 'field_image_default',
                    },
                    data: {
                        target_id: '82',
                        target_revision_id: '2450',
                    },
                    field_name: 'field_group',
                },
                {
                    id: 85,
                    langcode: 'de',
                    type: 'image_simple',
                    status: true,
                    parent_field_name: 'field_group',
                    field_link: 'https://www.imwalking.de/p/versandkosten-flatrate/99886384-0-632913405#lmPromo=la,2,hk,Startseite,fl,Startseite_VKPFlat',
                    field_tracking: 'lmPromo=la,2,hk,Startseite,fl,Startseite_VKPFlat',
                    field_type: 'media',
                    image_default: {
                        fid: 53,
                        langcode: 'de',
                        filename: 'hp_topshop_marke_vkp-flat_kw36_2019.jpg',
                        uri: 'public://2019-09/hp_topshop_marke_vkp-flat_kw36_2019.jpg',
                        url: '{STORYBOOK}/565x364.png',
                        filemime: 'image/jpeg',
                        filesize: 53913,
                        status: true,
                        data: {
                            target_id: '53',
                            alt: "Versandkostenfrei bestellen mit der I'm walking Flatrate",
                            title: "Versandkostenfrei bestellen mit der I'm walking Flatrate",
                            width: '564',
                            height: '364',
                        },
                        lang: 'de',
                        field_name: 'field_image_default',
                    },
                    data: {
                        target_id: '85',
                        target_revision_id: '2451',
                    },
                    field_name: 'field_group',
                },
            ],
            field_margin: '0 0 40px 0',
            field_row_gap: '10px',
            field_type: 'group',
            data: {
                target_id: '83',
                target_revision_id: '2452',
            },
            field_name: 'field_paragraph_iaw',
        },
        {
            id: 39,
            langcode: 'de',
            type: 'group',
            status: true,
            parent_field_name: 'field_paragraph_iaw',
            field_cells_per_row: 4,
            field_col_gap: '10px',
            paragraph: [
                {
                    id: 43,
                    langcode: 'de',
                    type: 'group',
                    status: true,
                    parent_field_name: 'field_group',
                    field_cells_per_row: 1,
                    paragraph: [
                        {
                            id: 41,
                            langcode: 'de',
                            type: 'headline',
                            status: true,
                            parent_field_name: 'field_group',
                            field_element_type: 'div',
                            field_level: 3,
                            field_margin_variant: 'medium',
                            field_text: 'Dein Vorteil',
                            field_text_align: 'center',
                            field_text_subheadline: 'Unser Service für Dich',
                            field_type: 'headline',
                            field_variation: 1,
                            data: {
                                target_id: '41',
                                target_revision_id: '2453',
                            },
                            field_name: 'field_group',
                        },
                        {
                            id: 73,
                            langcode: 'de',
                            type: 'feedback_teaser',
                            status: true,
                            parent_field_name: 'field_group',
                            field_bonus_number: '54110',
                            file: [
                                {
                                    fid: 48,
                                    langcode: 'de',
                                    filename: 'FeedbackTeaser_0.jpg',
                                    uri: 'public://2019-08/FeedbackTeaser_0.jpg',
                                    url: '{STORYBOOK}/feedbackteaser_initial.jpg',
                                    filemime: 'image/jpeg',
                                    filesize: 54661,
                                    status: true,
                                    data: {
                                        target_id: '48',
                                        alt: '',
                                        title: '',
                                        width: '277',
                                        height: '364',
                                    },
                                    field_name: 'field_feedback_image',
                                },
                                {
                                    fid: 51,
                                    langcode: 'de',
                                    filename: 'feedbackteaser_success_0.gif',
                                    uri: 'public://2019-08/feedbackteaser_success_0.gif',
                                    url: '{STORYBOOK}/feedbackteaser_success.png',
                                    filemime: 'image/gif',
                                    filesize: 473119,
                                    status: true,
                                    data: {
                                        target_id: '51',
                                        alt: '',
                                        title: '',
                                        width: '200',
                                        height: '270',
                                    },
                                    field_name: 'field_feedback_image_success',
                                },
                            ],
                            field_tracking: 'la,2,hk,Startseite,fl,Startseite_FeedbackTeaser',
                            field_type: 'feedbackteaser',
                            data: {
                                target_id: '73',
                                target_revision_id: '2454',
                            },
                            field_name: 'field_group',
                        },
                    ],
                    field_type: 'group',
                    data: {
                        target_id: '43',
                        target_revision_id: '2455',
                    },
                    field_name: 'field_group',
                },
                {
                    id: 38,
                    langcode: 'de',
                    type: 'group',
                    status: true,
                    parent_field_name: 'field_group',
                    field_cells_per_row: 1,
                    paragraph: [
                        {
                            id: 40,
                            langcode: 'de',
                            type: 'headline',
                            status: true,
                            parent_field_name: 'field_group',
                            field_element_type: 'div',
                            field_level: 3,
                            field_margin_variant: 'medium',
                            field_text: 'Sandalen',
                            field_text_align: 'center',
                            field_text_subheadline: 'Vielfalt',
                            field_type: 'headline',
                            field_variation: 1,
                            data: {
                                target_id: '40',
                                target_revision_id: '2456',
                            },
                            field_name: 'field_group',
                        },
                        {
                            id: 37,
                            langcode: 'de',
                            type: 'image_simple',
                            status: true,
                            parent_field_name: 'field_group',
                            field_link: 'https://www.imwalking.de/damenschuhe/sandalen/#highlight=25078937,83329423&lmPromo=la,2,hk,Startseite,fl,Startseite_Topshop2a',
                            field_tracking: 'la,2,hk,Startseite,fl,Startseite_Topshop2a',
                            field_type: 'media',
                            image_default: {
                                fid: 22,
                                langcode: 'de',
                                filename: 'test_topshop_1.jpg',
                                uri: 'public://2019-08/test_topshop_1.jpg',
                                url: '{STORYBOOK}/277x364.png',
                                filemime: 'image/jpeg',
                                filesize: 15302,
                                status: true,
                                data: {
                                    target_id: '22',
                                    alt: 'Topshop 1',
                                    title: 'Topshop 1',
                                    width: '277',
                                    height: '364',
                                },
                                lang: 'de',
                                field_name: 'field_image_default',
                            },
                            data: {
                                target_id: '37',
                                target_revision_id: '2457',
                            },
                            field_name: 'field_group',
                        },
                    ],
                    field_type: 'group',
                    data: {
                        target_id: '38',
                        target_revision_id: '2458',
                    },
                    field_name: 'field_group',
                },
                {
                    id: 46,
                    langcode: 'de',
                    type: 'group',
                    status: true,
                    parent_field_name: 'field_group',
                    field_cells_per_row: 1,
                    paragraph: [
                        {
                            id: 44,
                            langcode: 'de',
                            type: 'headline',
                            status: true,
                            parent_field_name: 'field_group',
                            field_element_type: 'div',
                            field_level: 3,
                            field_margin_variant: 'medium',
                            field_text: 'Pumps',
                            field_text_align: 'center',
                            field_text_subheadline: 'Liebe',
                            field_type: 'headline',
                            field_variation: 1,
                            data: {
                                target_id: '44',
                                target_revision_id: '2459',
                            },
                            field_name: 'field_group',
                        },
                        {
                            id: 45,
                            langcode: 'de',
                            type: 'image_simple',
                            status: true,
                            parent_field_name: 'field_group',
                            field_link: 'https://www.imwalking.de/damenschuhe/pumps/#highlight=95094741&lmPromo=la,2,hk,Startseite,fl,Startseite_Topshop3a',
                            field_tracking: 'la,2,hk,Startseite,fl,Startseite_Topshop3a',
                            field_type: 'media',
                            image_default: {
                                fid: 25,
                                langcode: 'de',
                                filename: 'test_topshop_2.jpg',
                                uri: 'public://2019-08/test_topshop_2.jpg',
                                url: '{STORYBOOK}/277x364.png',
                                filemime: 'image/jpeg',
                                filesize: 6608,
                                status: true,
                                data: {
                                    target_id: '25',
                                    alt: 'Topshop 2',
                                    title: 'Topshop 2',
                                    width: '277',
                                    height: '364',
                                },
                                lang: 'de',
                                field_name: 'field_image_default',
                            },
                            data: {
                                target_id: '45',
                                target_revision_id: '2460',
                            },
                            field_name: 'field_group',
                        },
                    ],
                    field_type: 'group',
                    data: {
                        target_id: '46',
                        target_revision_id: '2461',
                    },
                    field_name: 'field_group',
                },
                {
                    id: 49,
                    langcode: 'de',
                    type: 'group',
                    status: true,
                    parent_field_name: 'field_group',
                    field_cells_per_row: 1,
                    paragraph: [
                        {
                            id: 47,
                            langcode: 'de',
                            type: 'headline',
                            status: true,
                            parent_field_name: 'field_group',
                            field_element_type: 'div',
                            field_level: 3,
                            field_margin_variant: 'medium',
                            field_text: 'Fashion',
                            field_text_align: 'center',
                            field_text_subheadline: 'Sommer',
                            field_type: 'headline',
                            field_variation: 1,
                            data: {
                                target_id: '47',
                                target_revision_id: '2462',
                            },
                            field_name: 'field_group',
                        },
                        {
                            id: 48,
                            langcode: 'de',
                            type: 'image_simple',
                            status: true,
                            parent_field_name: 'field_group',
                            field_link: 'https://www.imwalking.de/fashion/#highlight=42376036,46396607,53440948&lmPromo=la,2,hk,Startseite,fl,Startseite_Topshop4a',
                            field_tracking: 'la,2,hk,Startseite,fl,Startseite_Topshop4a',
                            field_type: 'media',
                            image_default: {
                                fid: 26,
                                langcode: 'de',
                                filename: 'test_topshop_3.jpg',
                                uri: 'public://2019-08/test_topshop_3.jpg',
                                url: '{STORYBOOK}/277x364.png',
                                filemime: 'image/jpeg',
                                filesize: 15216,
                                status: true,
                                data: {
                                    target_id: '26',
                                    alt: 'Topshop 3',
                                    title: 'Topshop 3',
                                    width: '277',
                                    height: '364',
                                },
                                lang: 'de',
                                field_name: 'field_image_default',
                            },
                            data: {
                                target_id: '48',
                                target_revision_id: '2463',
                            },
                            field_name: 'field_group',
                        },
                    ],
                    field_type: 'group',
                    data: {
                        target_id: '49',
                        target_revision_id: '2464',
                    },
                    field_name: 'field_group',
                },
            ],
            field_type: 'group',
            data: {
                target_id: '39',
                target_revision_id: '2465',
            },
            field_name: 'field_paragraph_iaw',
        },
        {
            id: 51,
            langcode: 'de',
            type: 'reco_magellan',
            status: true,
            parent_field_name: 'field_paragraph_iaw',
            field_reco_type: 'default',
            field_shop_id: 'sh608988',
            field_type: 'reco_magellan',
            data: {
                target_id: '51',
                target_revision_id: '2466',
            },
            field_name: 'field_paragraph_iaw',
        },
        {
            id: 53,
            langcode: 'de',
            type: 'headline',
            status: true,
            parent_field_name: 'field_paragraph_iaw',
            field_element_type: 'div',
            field_level: 3,
            field_margin_variant: 'medium',
            field_text: 'Unsere Top-Marken',
            field_text_align: 'center',
            field_text_subheadline: 'und noch vieles mehr!',
            field_type: 'headline',
            field_variation: 1,
            data: {
                target_id: '53',
                target_revision_id: '2467',
            },
            field_name: 'field_paragraph_iaw',
        },
        {
            id: 55,
            langcode: 'de',
            type: 'group',
            status: true,
            parent_field_name: 'field_paragraph_iaw',
            field_cells_per_row: 6,
            field_col_gap: '10px',
            paragraph: [
                {
                    id: 54,
                    langcode: 'de',
                    type: 'image_simple',
                    status: true,
                    parent_field_name: 'field_group',
                    field_link: 'https://www.imwalking.de/marken/tamaris/#lmPromo=la,2,hk,Startseite,fl,Startseite_Marke1',
                    field_tracking: 'la,2,hk,Startseite,fl,Startseite_Marke1',
                    field_type: 'media',
                    image_default: {
                        fid: 27,
                        langcode: 'de',
                        filename: 'Logo_SF_tamaris.jpg',
                        uri: 'public://2019-08/Logo_SF_tamaris.jpg',
                        url: '{STORYBOOK}/185x82.png',
                        filemime: 'image/gif',
                        filesize: 1092,
                        status: true,
                        data: {
                            target_id: '27',
                            alt: 'Tamaris',
                            title: 'Tamaris',
                            width: '199',
                            height: '88',
                        },
                        lang: 'de',
                        field_name: 'field_image_default',
                    },
                    data: {
                        target_id: '54',
                        target_revision_id: '2468',
                    },
                    field_name: 'field_group',
                },
                {
                    id: 56,
                    langcode: 'de',
                    type: 'image_simple',
                    status: true,
                    parent_field_name: 'field_group',
                    field_link: 'https://www.imwalking.de/marken/as98/#lmPromo=la,2,hk,Startseite,fl,Startseite_Marke2',
                    field_tracking: 'la,2,hk,Startseite,fl,Startseite_Marke2',
                    field_type: 'media',
                    image_default: {
                        fid: 28,
                        langcode: 'de',
                        filename: 'Logo_SF_as98_neu.gif',
                        uri: 'public://2019-08/Logo_SF_as98_neu.gif',
                        url: '{STORYBOOK}/185x82.png',
                        filemime: 'image/gif',
                        filesize: 2852,
                        status: true,
                        data: {
                            target_id: '28',
                            alt: 'A.S. 98',
                            title: 'A.S. 98',
                            width: '185',
                            height: '82',
                        },
                        lang: 'de',
                        field_name: 'field_image_default',
                    },
                    data: {
                        target_id: '56',
                        target_revision_id: '2469',
                    },
                    field_name: 'field_group',
                },
                {
                    id: 57,
                    langcode: 'de',
                    type: 'image_simple',
                    status: true,
                    parent_field_name: 'field_group',
                    field_link: 'https://www.imwalking.de/marken/rieker/#lmPromo=la,2,hk,Startseite,fl,Startseite_Marke3',
                    field_tracking: 'la,2,hk,Startseite,fl,Startseite_Marke3',
                    field_type: 'media',
                    image_default: {
                        fid: 31,
                        langcode: 'de',
                        filename: 'Logo_SF_rieker_0.gif',
                        uri: 'public://2019-08/Logo_SF_rieker_0.gif',
                        url: '{STORYBOOK}/185x82.png',
                        filemime: 'image/gif',
                        filesize: 3516,
                        status: true,
                        data: {
                            target_id: '31',
                            alt: 'Rieker',
                            title: 'Rieker',
                            width: '185',
                            height: '82',
                        },
                        lang: 'de',
                        field_name: 'field_image_default',
                    },
                    data: {
                        target_id: '57',
                        target_revision_id: '2470',
                    },
                    field_name: 'field_group',
                },
                {
                    id: 58,
                    langcode: 'de',
                    type: 'image_simple',
                    status: true,
                    parent_field_name: 'field_group',
                    field_link: 'https://www.imwalking.de/marken/nike/#lmPromo=la,2,hk,Startseite,fl,Startseite_Marke4',
                    field_tracking: 'la,2,hk,Startseite,fl,Startseite_Marke4',
                    field_type: 'media',
                    image_default: {
                        fid: 32,
                        langcode: 'de',
                        filename: 'Logo_SF_nike_neu_0.gif',
                        uri: 'public://2019-08/Logo_SF_nike_neu_0.gif',
                        url: '{STORYBOOK}/185x82.png',
                        filemime: 'image/gif',
                        filesize: 2813,
                        status: true,
                        data: {
                            target_id: '32',
                            alt: 'Nike',
                            title: 'Nike',
                            width: '185',
                            height: '82',
                        },
                        lang: 'de',
                        field_name: 'field_image_default',
                    },
                    data: {
                        target_id: '58',
                        target_revision_id: '2471',
                    },
                    field_name: 'field_group',
                },
                {
                    id: 59,
                    langcode: 'de',
                    type: 'image_simple',
                    status: true,
                    parent_field_name: 'field_group',
                    field_link: 'https://www.imwalking.de/marken/bugatti/#lmPromo=la,2,hk,Startseite,fl,Startseite_Marke5',
                    field_tracking: 'la,2,hk,Startseite,fl,Startseite_Marke5',
                    field_type: 'media',
                    image_default: {
                        fid: 33,
                        langcode: 'de',
                        filename: 'Logo_SF_bugatti__neu.gif',
                        uri: 'public://2019-08/Logo_SF_bugatti__neu.gif',
                        url: '{STORYBOOK}/185x82.png',
                        filemime: 'image/gif',
                        filesize: 2678,
                        status: true,
                        data: {
                            target_id: '33',
                            alt: 'Bugatti',
                            title: 'Bugatti',
                            width: '185',
                            height: '82',
                        },
                        lang: 'de',
                        field_name: 'field_image_default',
                    },
                    data: {
                        target_id: '59',
                        target_revision_id: '2472',
                    },
                    field_name: 'field_group',
                },
                {
                    id: 60,
                    langcode: 'de',
                    type: 'image_simple',
                    status: true,
                    parent_field_name: 'field_group',
                    field_link: 'https://www.imwalking.de/marken/skechers/#lmPromo=la,2,hk,Startseite,fl,Startseite_Marke6',
                    field_tracking: 'la,2,hk,Startseite,fl,Startseite_Marke6',
                    field_type: 'media',
                    image_default: {
                        fid: 34,
                        langcode: 'de',
                        filename: 'Logo_SF_skechers.gif',
                        uri: 'public://2019-08/Logo_SF_skechers.gif',
                        url: '{STORYBOOK}/185x82.png',
                        filemime: 'image/gif',
                        filesize: 2261,
                        status: true,
                        data: {
                            target_id: '34',
                            alt: 'Sketchers',
                            title: 'Sketchers',
                            width: '185',
                            height: '82',
                        },
                        lang: 'de',
                        field_name: 'field_image_default',
                    },
                    data: {
                        target_id: '60',
                        target_revision_id: '2473',
                    },
                    field_name: 'field_group',
                },
                {
                    id: 61,
                    langcode: 'de',
                    type: 'image_simple',
                    status: true,
                    parent_field_name: 'field_group',
                    field_link: 'https://www.imwalking.de/marken/paul-green/#lmPromo=la,2,hk,Startseite,fl,Startseite_Marke7',
                    field_tracking: 'la,2,hk,Startseite,fl,Startseite_Marke7',
                    field_type: 'media',
                    image_default: {
                        fid: 35,
                        langcode: 'de',
                        filename: 'Logo_SF_paulgreen_neu.gif',
                        uri: 'public://2019-08/Logo_SF_paulgreen_neu.gif',
                        url: '{STORYBOOK}/185x82.png',
                        filemime: 'image/gif',
                        filesize: 2865,
                        status: true,
                        data: {
                            target_id: '35',
                            alt: 'Paul Green',
                            title: 'Paul Green',
                            width: '185',
                            height: '82',
                        },
                        lang: 'de',
                        field_name: 'field_image_default',
                    },
                    data: {
                        target_id: '61',
                        target_revision_id: '2474',
                    },
                    field_name: 'field_group',
                },
                {
                    id: 62,
                    langcode: 'de',
                    type: 'image_simple',
                    status: true,
                    parent_field_name: 'field_group',
                    field_link: 'https://www.imwalking.de/marken/tommy-hilfiger/#lmPromo=la,2,hk,Startseite,fl,Startseite_Marke8',
                    field_tracking: 'la,2,hk,Startseite,fl,Startseite_Marke8',
                    field_type: 'media',
                    image_default: {
                        fid: 36,
                        langcode: 'de',
                        filename: 'Logo_SF_tommyhilfiger.gif',
                        uri: 'public://2019-08/Logo_SF_tommyhilfiger.gif',
                        url: '{STORYBOOK}/185x82.png',
                        filemime: 'image/gif',
                        filesize: 2861,
                        status: true,
                        data: {
                            target_id: '36',
                            alt: 'Tommy Hilfiger',
                            title: 'Tommy Hilfiger',
                            width: '185',
                            height: '82',
                        },
                        lang: 'de',
                        field_name: 'field_image_default',
                    },
                    data: {
                        target_id: '62',
                        target_revision_id: '2475',
                    },
                    field_name: 'field_group',
                },
                {
                    id: 63,
                    langcode: 'de',
                    type: 'image_simple',
                    status: true,
                    parent_field_name: 'field_group',
                    field_link: 'https://www.imwalking.de/marken/gabor/#lmPromo=la,2,hk,Startseite,fl,Startseite_Marke9',
                    field_tracking: 'la,2,hk,Startseite,fl,Startseite_Marke9',
                    field_type: 'media',
                    image_default: {
                        fid: 37,
                        langcode: 'de',
                        filename: 'Logo_SF_gabor.gif',
                        uri: 'public://2019-08/Logo_SF_gabor.gif',
                        url: '{STORYBOOK}/185x82.png',
                        filemime: 'image/gif',
                        filesize: 2778,
                        status: true,
                        data: {
                            target_id: '37',
                            alt: 'Gabor',
                            title: 'Gabor',
                            width: '185',
                            height: '82',
                        },
                        lang: 'de',
                        field_name: 'field_image_default',
                    },
                    data: {
                        target_id: '63',
                        target_revision_id: '2476',
                    },
                    field_name: 'field_group',
                },
                {
                    id: 64,
                    langcode: 'de',
                    type: 'image_simple',
                    status: true,
                    parent_field_name: 'field_group',
                    field_link: 'https://www.imwalking.de/marken/tom-tailor/#lmPromo=la,2,hk,Startseite,fl,Startseite_Marke10',
                    field_tracking: 'la,2,hk,Startseite,fl,Startseite_Marke10',
                    field_type: 'media',
                    image_default: {
                        fid: 38,
                        langcode: 'de',
                        filename: 'Logo_SF_tomtailor.png',
                        uri: 'public://2019-08/Logo_SF_tomtailor.png',
                        url: '{STORYBOOK}/185x82.png',
                        filemime: 'image/gif',
                        filesize: 3574,
                        status: true,
                        data: {
                            target_id: '38',
                            alt: 'Tom Tailor',
                            title: 'Tom Tailor',
                            width: '185',
                            height: '82',
                        },
                        lang: 'de',
                        field_name: 'field_image_default',
                    },
                    data: {
                        target_id: '64',
                        target_revision_id: '2477',
                    },
                    field_name: 'field_group',
                },
                {
                    id: 65,
                    langcode: 'de',
                    type: 'image_simple',
                    status: true,
                    parent_field_name: 'field_group',
                    field_link: 'https://www.imwalking.de/marken/mustang/#lmPromo=la,2,hk,Startseite,fl,Startseite_Marke11',
                    field_tracking: 'la,2,hk,Startseite,fl,Startseite_Marke11',
                    field_type: 'media',
                    image_default: {
                        fid: 39,
                        langcode: 'de',
                        filename: 'Logo_SF_mustang.gif',
                        uri: 'public://2019-08/Logo_SF_mustang.gif',
                        url: '{STORYBOOK}/185x82.png',
                        filemime: 'image/gif',
                        filesize: 3800,
                        status: true,
                        data: {
                            target_id: '39',
                            alt: 'Mustang',
                            title: 'Mustang',
                            width: '185',
                            height: '82',
                        },
                        lang: 'de',
                        field_name: 'field_image_default',
                    },
                    data: {
                        target_id: '65',
                        target_revision_id: '2478',
                    },
                    field_name: 'field_group',
                },
                {
                    id: 66,
                    langcode: 'de',
                    type: 'image_simple',
                    status: true,
                    parent_field_name: 'field_group',
                    field_link: 'https://www.imwalking.de/marken/birkenstock/#lmPromo=la,2,hk,Startseite,fl,Startseite_Marke12',
                    field_tracking: 'la,2,hk,Startseite,fl,Startseite_Marke12',
                    field_type: 'media',
                    image_default: {
                        fid: 40,
                        langcode: 'de',
                        filename: 'Logo_SF_birkenstock.gif',
                        uri: 'public://2019-08/Logo_SF_birkenstock.gif',
                        url: '{STORYBOOK}/185x82.png',
                        filemime: 'image/gif',
                        filesize: 3319,
                        status: true,
                        data: {
                            target_id: '40',
                            alt: 'Birkenstock',
                            title: 'Birkenstock',
                            width: '185',
                            height: '82',
                        },
                        lang: 'de',
                        field_name: 'field_image_default',
                    },
                    data: {
                        target_id: '66',
                        target_revision_id: '2479',
                    },
                    field_name: 'field_group',
                },
            ],
            field_row_gap: '10px',
            field_type: 'group',
            data: {
                target_id: '55',
                target_revision_id: '2480',
            },
            field_name: 'field_paragraph_iaw',
        },
        {
            id: 52,
            langcode: 'de',
            type: 'reco_prudsys',
            status: true,
            parent_field_name: 'field_paragraph_iaw',
            field_reco_type: 'ec-homepage',
            field_type: 'reco_prudsys',
            data: {
                target_id: '52',
                target_revision_id: '2481',
            },
            field_name: 'field_paragraph_iaw',
        },
        {
            id: 67,
            langcode: 'de',
            type: 'headline',
            status: true,
            parent_field_name: 'field_paragraph_iaw',
            field_element_type: 'div',
            field_level: 3,
            field_margin_variant: 'medium',
            field_text: 'Unser Service für dich',
            field_text_align: 'center',
            field_text_subheadline: 'Damit du stets gut beraten & informiert und so mit deinem Online-Shopping-Erlebnis rundum zufrieden bist!',
            field_type: 'headline',
            field_variation: 1,
            data: {
                target_id: '67',
                target_revision_id: '2482',
            },
            field_name: 'field_paragraph_iaw',
        },
        {
            id: 70,
            langcode: 'de',
            type: 'group',
            status: true,
            parent_field_name: 'field_paragraph_iaw',
            field_cells_per_row: 2,
            field_col_gap: '10px',
            paragraph: [
                {
                    id: 68,
                    langcode: 'de',
                    type: 'image_simple',
                    status: true,
                    parent_field_name: 'field_group',
                    field_link: 'https://app.adjust.com/c7hxco_254gzc?campaign=Storefront-Banner&adgroup=Container_unten_rechts&creative=HW18&fallback=https%3A%2F%2Fwww.imwalking.de%2Fservice-kontakt%2Fim-walking-app%2F#lmPromo=la,2,hk,Startseite,fl,Startseite_App',
                    field_tracking: 'la,2,hk,Startseite,fl,Startseite_App',
                    field_type: 'media',
                    image_default: {
                        fid: 41,
                        langcode: 'de',
                        filename: 'app.jpg',
                        uri: 'public://2019-08/app.jpg',
                        url: '{STORYBOOK}/565x364.png',
                        filemime: 'image/jpeg',
                        filesize: 26562,
                        status: true,
                        data: {
                            target_id: '41',
                            alt: 'Jederzeit Mobil shoppen',
                            title: 'Jederzeit Mobil shoppen',
                            width: '565',
                            height: '364',
                        },
                        lang: 'de',
                        field_name: 'field_image_default',
                    },
                    data: {
                        target_id: '68',
                        target_revision_id: '2483',
                    },
                    field_name: 'field_group',
                },
                {
                    id: 69,
                    langcode: 'de',
                    type: 'image_simple',
                    status: true,
                    parent_field_name: 'field_group',
                    field_link: 'https://www.imwalking.de/service-kontakt/schuhratgeber/#lmPromo=la,2,hk,Startseite,fl,Startseite_Ratgeber',
                    field_tracking: 'la,2,hk,Startseite,fl,Startseite_Ratgeber',
                    field_type: 'media',
                    image_default: {
                        fid: 42,
                        langcode: 'de',
                        filename: 'schuhratgeber.jpg',
                        uri: 'public://2019-08/schuhratgeber.jpg',
                        url: '{STORYBOOK}/565x364.png',
                        filemime: 'image/jpeg',
                        filesize: 41450,
                        status: true,
                        data: {
                            target_id: '42',
                            alt: 'Schuhratgeber',
                            title: 'Schuhratgeber',
                            width: '565',
                            height: '364',
                        },
                        lang: 'de',
                        field_name: 'field_image_default',
                    },
                    data: {
                        target_id: '69',
                        target_revision_id: '2484',
                    },
                    field_name: 'field_group',
                },
            ],
            field_row_gap: '10px',
            field_type: 'group',
            data: {
                target_id: '70',
                target_revision_id: '2485',
            },
            field_name: 'field_paragraph_iaw',
        },
        {
            id: 161,
            langcode: 'de',
            type: 'html',
            status: true,
            parent_field_name: 'field_paragraph_iaw',
            field_html_editor: '<h3>tester</h3>\r\n\r\n<ol>\r\n\t<li>bla</li>\r\n\t<li>fasel</li>\r\n\t<li>blub</li>\r\n</ol>\r\n\r\n<p><em>Schräg</em></p>\r\n',
            data: {
                target_id: '161',
                target_revision_id: '12710',
            },
            field_name: 'field_paragraph_iaw',
        },
        {
            type: 'unknown',
            content: 'should neither crash the recognizer nor be shown',
        },
        {
            id: 4250,
            langcode: 'de',
            type: 'accordion',
            status: true,
            parent_field_name: 'field_paragraph_iaw',
            field_margin: '2rem 0',
            field_type: 'accordion',
            field_name: 'field_paragraph_iaw',
            field_style_type: 'default',
            paragraph: [
                {
                    id: 4251,
                    langcode: 'de',
                    type: 'collapse',
                    status: true,
                    parent_field_name: 'field_accordion_content',
                    field_type: 'collapse',
                    field_html_editor: '<h3>tester</h3><ol><li>bla</li><li>fasel</li><li>blub</li></ol><p><em>Schräg</em></p>',
                    field_headline: 'Test 1',
                    field_name: 'field_accordion_content',
                    field_is_open: false,
                },
                {
                    id: 4252,
                    langcode: 'de',
                    type: 'collapse',
                    status: true,
                    parent_field_name: 'field_accordion_content',
                    field_type: 'collapse',
                    field_html_editor: '<h3>tester</h3><ol><li>bla</li><li>fasel</li><li>blub</li></ol><p><em>Schräg</em></p>',
                    field_headline: 'Test 2',
                    field_name: 'field_accordion_content',
                    field_is_open: false,
                },
                {
                    id: 4253,
                    langcode: 'de',
                    type: 'collapse',
                    status: true,
                    parent_field_name: 'field_accordion_content',
                    field_type: 'collapse',
                    field_html_editor: '<p>Cultivar mug macchiato dark doppio lungo, coffee aromatic brewed con panna milk. Sugar trifecta redeye, decaffeinated, qui mug, chicory ut est robust carajillo caramelization. Coffee latte qui wings froth coffee affogato con panna affogato. Breve robusta, so, saucer, et grounds arabica a steamed cultivar variety americano.<p/>',
                    field_headline: 'Test 3',
                    field_name: 'field_accordion_content',
                    field_is_open: false,
                },
            ],
        },
        {
            id: 186,
            langcode: 'de',
            type: 'list',
            status: true,
            parent_field_name: 'field_paragraph_iaw',
            paragraph: [
                {
                    id: 184,
                    langcode: 'de',
                    type: 'html',
                    status: true,
                    parent_field_name: 'field_item',
                    field_html_editor: 'Erstes Listenelement',
                    data: {
                        target_id: '184',
                        target_revision_id: '13575',
                    },
                    field_name: 'field_item',
                },
                {
                    id: 185,
                    langcode: 'de',
                    type: 'html',
                    status: true,
                    parent_field_name: 'field_item',
                    field_html_editor: 'Zweites Listenelement',
                    data: {
                        target_id: '185',
                        target_revision_id: '13576',
                    },
                    field_name: 'field_item',
                },
            ],
            field_modus: 'sorted',
            field_orientation: 'horizontal',
            field_separator: '\\007C',
            data: {
                target_id: '186',
                target_revision_id: '13577',
            },
            field_name: 'field_paragraph_iaw',
        },
        {
            id: 219,
            langcode: 'de',
            type: 'text_with_link',
            status: true,
            parent_field_name: 'field_paragraph_iaw',
            field_content: 'Ein Text mit [Platzhalter] - und Text danach',
            paragraph: [
                {
                    id: 218,
                    langcode: 'de',
                    type: 'modal',
                    status: true,
                    parent_field_name: 'field_modal',
                    field_content: 'Modalinhalt',
                    field_headline: 'Modalüberschrift',
                    field_placeholder_id: '[Platzhalter]',
                    field_placeholder_text: 'Platzhalter',
                    data: {
                        target_id: '218',
                        target_revision_id: '13761',
                    },
                    field_name: 'field_modal',
                },
            ],
            data: {
                target_id: '219',
                target_revision_id: '13762',
            },
            field_name: 'field_paragraph_iaw',
        },
        {
            id: 221,
            langcode: 'de',
            type: 'externalscript',
            status: true,
            parent_field_name: 'field_paragraph_iaw',
            field_api_key: 'X1E7D90DEBEF5E6B503C02DC28BD031F3',
            field_script_type: 'trustedShops',
            data: {
                target_id: '221',
                target_revision_id: '13915',
            },
            field_name: 'field_paragraph_iaw',
        },
        {
            id: 369,
            langcode: 'de',
            type: 'link_by_button',
            status: true,
            parent_field_name: 'field_paragraph_iaw',
            field_link: 'https://www.imwalking.de/',
            field_text: 'Buttontext',
            data: {
                target_id: '369',
                target_revision_id: '19571',
            },
            field_name: 'field_paragraph_iaw',
            field_layout: 'primary',
            field_icon: 'ArrowLeft',
            field_direction: 'left',
            field_link_target: '_blank',
        },
        {
            id: 370,
            langcode: 'de',
            type: 'link_by_text',
            status: true,
            parent_field_name: 'field_paragraph_iaw',
            field_direction: 'left',
            field_icon: 'ArrowLeft',
            field_link: 'https://www.imwalking.de',
            field_link_target: '_blank',
            field_text: 'Linktext',
            data: {
                target_id: '370',
                target_revision_id: '19905',
            },
            field_name: 'field_paragraph_iaw',
        },
        {
            id: 245,
            langcode: 'de',
            type: 'buttonlink_modal',
            status: true,
            parent_field_name: 'field_buttonlink_modal',
            field_headline: 'Die Überschrift meines Modals',
            field_html_editor: 'Der Inhalt meines Modals',
            field_text: 'Mein Buttontext',
            data: { target_id: '245', target_revision_id: '14595' },
            field_name: 'field_buttonlink_modal',
        },
        {
            id: 366,
            langcode: 'de',
            type: 'section_seperator',
            status: true,
            parent_field_name: 'field_paragraph_iaw',
            field_margin_variant: 'medium',
            field_style_type: 'default',
            field_type: 'section_seperator',
            data: {
                target_id: '366',
                target_revision_id: '19392',
            },
            lang: 'de',
            field_name: 'field_paragraph_iaw',
        },
        {
            id: 329,
            langcode: 'de',
            type: 'flexible_teaser',
            status: true,
            parent_field_name: 'field_image_paragraphs',
            field_background_color: 'rgba(255,255,255,0.7)',
            field_border_color: 'rgba(0,0,0,0.5)',
            field_headline: 'WASCH-MASCHINEN',
            field_layout_variant: '1a',
            field_vertical_alignment: 'center',
            field_link: 'https://test.com',
            field_link_target: '_blank',
            field_negative_text_color: false,
            field_size: 'big',
            field_size_subheadline: 'small',
            field_text_subheadline: 'Pflege für deine Lieblingsstücke',
            data: {
                target_id: '329',
                target_revision_id: '20764',
            },
            lang: 'de',
            field_name: 'field_image_paragraphs',
        },
        {
            id: 1,
            langcode: 'de',
            type: 'externalscript',
            status: true,
            parent_field_name: 'field_paragraphs',
            content_translation_changed: '2020-11-09T13:06:33+00:00',
            field_api_key: 'D4nhRRxb',
            field_script_type: 'zoovu',
            data: {
                target_id: '1',
                target_revision_id: '1',
            },
            field_name: 'field_paragraphs',
        },
    ],
};
exports.cmsdataLibraryItemNested = {
    webapp_version: 1,
    revisionId: '7',
    menus: {
        custom: [],
        footer: [],
        main: [],
        service: [],
        shop: [],
        active: false,
    },
    alternateLinks: {
        de: 'http://emp-drupal.ddev.site:7080/de/testpagemgruben',
    },
    nid: 1,
    langcode: 'de',
    type: 'content',
    status: false,
    title: 'Testpage mgruben',
    promote: false,
    sticky: false,
    moderation_state: 'draft',
    path: [
        {
            alias: '/testpagemgruben',
            pid: 1,
            langcode: 'de',
            lang: 'de',
            field_name: 'path',
        },
    ],
    paragraph: [
        {
            id: 5,
            langcode: 'de',
            type: 'from_library',
            status: true,
            parent_field_name: 'field_paragraphs',
            content_translation_changed: '2020-06-25T10:55:46+00:00',
            paragraphs_library_item: [
                {
                    id: 1,
                    langcode: 'de',
                    status: true,
                    label: 'Purple Headline',
                    paragraph: [
                        {
                            id: 4,
                            langcode: 'de',
                            type: 'headline',
                            status: true,
                            parent_field_name: 'paragraphs',
                            content_translation_changed: '2020-06-25T10:55:33+00:00',
                            field_distance: 'default',
                            field_element_type: 'div',
                            field_font: 'default',
                            field_font_color: 'purple',
                            field_level: 3,
                            field_margin_variant: 'none',
                            field_text: 'Headline as library-item',
                            field_text_align: 'center',
                            field_text_subheadline: 'with subheadline',
                            field_type: 'headline',
                            field_variation: 1,
                            data: {
                                target_id: '4',
                                target_revision_id: '7',
                            },
                            field_name: 'paragraphs',
                        },
                    ],
                    data: {
                        target_id: '1',
                    },
                    field_name: 'field_reusable_paragraph',
                },
            ],
            data: {
                target_id: '5',
                target_revision_id: '24',
            },
            field_name: 'field_paragraphs',
        },
        {
            id: 16,
            langcode: 'de',
            type: 'from_library',
            status: true,
            parent_field_name: 'field_paragraphs',
            content_translation_changed: '2020-07-01T10:35:09+00:00',
            paragraphs_library_item: [
                {
                    id: 2,
                    langcode: 'de',
                    status: true,
                    label: 'Bildgruppe mit Library-Item',
                    paragraph: [
                        {
                            id: 15,
                            langcode: 'de',
                            type: 'group',
                            status: true,
                            parent_field_name: 'paragraphs',
                            content_translation_changed: '2020-07-01T10:35:01+00:00',
                            field_alignment: 'space-between',
                            field_cells_per_row: 2,
                            paragraph: [
                                {
                                    id: 11,
                                    langcode: 'de',
                                    type: 'image_simple',
                                    status: true,
                                    parent_field_name: 'field_group',
                                    content_translation_changed: '2020-07-01T10:35:01+00:00',
                                    field_display_variant: 'default',
                                    field_image_size_type: 'max-width',
                                    field_lazyload: false,
                                    field_persist_target: false,
                                    field_type: 'media',
                                    field_valid_from: '2020-07-01T12:32:24+02:00',
                                    image_default: {
                                        fid: 2,
                                        langcode: 'en',
                                        filename: 'well_0.jpg',
                                        uri: 'cloud-storage-develop-mg://2020-07/well_0.jpg',
                                        url: '{STORYBOOK}/1140x450.png',
                                        filemime: 'image/jpeg',
                                        filesize: 30296,
                                        status: true,
                                        data: {
                                            target_id: '2',
                                            alt: 'well',
                                            title: 'well',
                                            width: '570',
                                            height: '402',
                                        },
                                        lang: 'de',
                                        field_name: 'field_image_default',
                                    },
                                    data: {
                                        target_id: '11',
                                        target_revision_id: '26',
                                    },
                                    field_name: 'field_group',
                                },
                                {
                                    id: 12,
                                    langcode: 'de',
                                    type: 'image_simple',
                                    status: true,
                                    parent_field_name: 'field_group',
                                    content_translation_changed: '2020-07-01T10:35:01+00:00',
                                    field_display_variant: 'default',
                                    field_image_size_type: 'max-width',
                                    field_lazyload: false,
                                    field_persist_target: false,
                                    field_type: 'media',
                                    field_valid_from: '2020-07-01T12:32:44+02:00',
                                    image_default: {
                                        fid: 3,
                                        langcode: 'en',
                                        filename: '20kw15-storefront-gartenmoebel_1.jpg',
                                        uri: 'cloud-storage-develop-mg://2020-07/20kw15-storefront-gartenmoebel_1.jpg',
                                        url: '{STORYBOOK}/1140x450.png',
                                        filemime: 'image/jpeg',
                                        filesize: 195473,
                                        status: true,
                                        data: {
                                            target_id: '3',
                                            alt: 'möbel',
                                            title: 'möbel',
                                            width: '1600',
                                            height: '500',
                                        },
                                        lang: 'de',
                                        field_name: 'field_image_default',
                                    },
                                    data: {
                                        target_id: '12',
                                        target_revision_id: '27',
                                    },
                                    field_name: 'field_group',
                                },
                                {
                                    id: 13,
                                    langcode: 'de',
                                    type: 'image_simple',
                                    status: true,
                                    parent_field_name: 'field_group',
                                    content_translation_changed: '2020-07-01T10:35:01+00:00',
                                    field_display_variant: 'default',
                                    field_image_size_type: 'max-width',
                                    field_lazyload: false,
                                    field_persist_target: false,
                                    field_type: 'media',
                                    field_valid_from: '2020-07-01T12:33:13+02:00',
                                    image_default: {
                                        fid: 4,
                                        langcode: 'en',
                                        filename: '20kw20-storefront-boxspringbetten_0.jpg',
                                        uri: 'cloud-storage-develop-mg://2020-07/20kw20-storefront-boxspringbetten_0.jpg',
                                        url: '{STORYBOOK}/1140x450.png',
                                        filemime: 'image/jpeg',
                                        filesize: 70080,
                                        status: true,
                                        data: {
                                            target_id: '4',
                                            alt: 'bett',
                                            title: 'bett',
                                            width: '1600',
                                            height: '500',
                                        },
                                        lang: 'de',
                                        field_name: 'field_image_default',
                                    },
                                    data: {
                                        target_id: '13',
                                        target_revision_id: '28',
                                    },
                                    field_name: 'field_group',
                                },
                                {
                                    id: 14,
                                    langcode: 'de',
                                    type: 'from_library',
                                    status: true,
                                    parent_field_name: 'field_group',
                                    content_translation_changed: '2020-07-01T10:35:01+00:00',
                                    paragraphs_library_item: [
                                        {
                                            id: 1,
                                            langcode: 'de',
                                            status: true,
                                            label: 'Purple Headline',
                                            paragraph: [
                                                {
                                                    id: 4,
                                                    langcode: 'de',
                                                    type: 'headline',
                                                    status: true,
                                                    parent_field_name: 'paragraphs',
                                                    content_translation_changed: '2020-06-25T10:55:33+00:00',
                                                    field_distance: 'default',
                                                    field_element_type: 'div',
                                                    field_font: 'default',
                                                    field_font_color: 'purple',
                                                    field_level: 3,
                                                    field_margin_variant: 'none',
                                                    field_text: 'Headline as nested library-item',
                                                    field_text_align: 'center',
                                                    field_text_subheadline: 'with subheadline',
                                                    field_type: 'headline',
                                                    field_variation: 1,
                                                    data: {
                                                        target_id: '4',
                                                        target_revision_id: '7',
                                                    },
                                                    field_name: 'paragraphs',
                                                },
                                            ],
                                            data: {
                                                target_id: '1',
                                            },
                                            field_name: 'field_reusable_paragraph',
                                        },
                                    ],
                                    data: {
                                        target_id: '14',
                                        target_revision_id: '29',
                                    },
                                    field_name: 'field_group',
                                },
                            ],
                            field_type: 'group',
                            field_valid_from: '2020-07-01T12:32:19+02:00',
                            data: {
                                target_id: '15',
                                target_revision_id: '30',
                            },
                            field_name: 'paragraphs',
                        },
                    ],
                    data: {
                        target_id: '2',
                    },
                    field_name: 'field_reusable_paragraph',
                },
            ],
            data: {
                target_id: '16',
                target_revision_id: '25',
            },
            field_name: 'field_paragraphs',
        },
    ],
};
exports.cmsdataIncludingDateRange = {
    webapp_version: 1,
    menus: {
        'baur-service': [
            {
                title: 'Allgemeine Kundenbetreueung',
                is_external: false,
                internal_path: 'node/13',
                alias: '/baurde/baur-service/allgemeine-kundenbetreueung',
            },
        ],
        'baur-shop': [
            {
                title: 'Damen',
                is_external: false,
                internal_path: 'node/12',
                alias: '/baurde/baur-shop/damen',
            },
            {
                title: 'test-juri',
                is_external: false,
                internal_path: 'node/17',
                alias: '/baurde/baur-shop/test-juri',
            },
        ],
        footer: [
            {
                title: 'Contact',
                is_external: false,
                internal_path: 'contact',
                alias: '/contact',
            },
        ],
        'iaw-service': [
            {
                title: 'Häufige Fragen (FAQ)',
                is_external: false,
                internal_path: 'node/11',
                alias: '/imwalkingde/iaw-service/haeufige-fragen-faq',
            },
            {
                title: 'test-stegmann2',
                is_external: false,
                internal_path: 'node/16',
                alias: '/imwalkingde/iaw-service/test-stegmann2',
            },
        ],
        'iaw-shop': [
            {
                title: 'Damen',
                is_external: false,
                internal_path: 'node/10',
                alias: '/imwalkingde/iaw-shop/damen',
            },
        ],
        main: [
            {
                title: 'Home',
                is_external: false,
                internal_path: '',
                alias: '/',
            },
        ],
    },
    nid: 7,
    langcode: 'de',
    type: 'imwalkingde',
    status: true,
    title: 'Homepage',
    promote: false,
    sticky: false,
    moderation_state: 'published',
    path: [
        {
            alias: '/emma-cms',
            pid: 8,
            langcode: 'de',
            lang: 'de',
            field_name: 'path',
        },
    ],
    field_pagegroup: 'KS_Homepage',
    paragraph: [
        {
            id: 30,
            langcode: 'de',
            type: 'slider',
            status: true,
            parent_field_name: 'field_paragraph_iaw',
            paragraph: [
                {
                    id: 32,
                    langcode: 'de',
                    type: 'image_simple',
                    status: true,
                    parent_field_name: 'field_group',
                    field_link: 'https://www.imwalking.de/damenschuhe/sneaker/#highlight=535728,518871,84608902,65254639,68313728&lmPromo=la,2,hk,Startseite,fl,Startseite_Flagship1',
                    field_tracking: 'la,2,hk,Startseite,fl,Startseite_Flagship1',
                    field_type: 'media',
                    image_default: {
                        fid: 14,
                        langcode: 'de',
                        filename: 'test_stage_1_1.jpg',
                        uri: 'public://2019-08/test_stage_1_1.jpg',
                        url: '{STORYBOOK}/1140x450.png',
                        filemime: 'image/jpeg',
                        filesize: 96153,
                        status: true,
                        data: {
                            target_id: '14',
                            alt: 'stage 1',
                            title: 'stage 1',
                            width: '1140',
                            height: '450',
                        },
                        lang: 'de',
                        field_name: 'field_image_default',
                    },
                    data: {
                        target_id: '32',
                        target_revision_id: '1382',
                    },
                    lang: 'de',
                    field_name: 'field_group',
                },
                {
                    id: 33,
                    langcode: 'de',
                    type: 'image_simple',
                    status: true,
                    parent_field_name: 'field_group',
                    field_link: 'https://www.imwalking.de/damenschuhe/sommerschuhe/#highlight=70742626,518871,54425610,42611862&lmPromo=la,2,hk,Startseite,fl,Startseite_Flagship2',
                    field_tracking: 'la,2,hk,Startseite,fl,Startseite_Flagship2',
                    field_type: 'media',
                    image_default: {
                        fid: 17,
                        langcode: 'de',
                        filename: 'test_stage_2_1.jpg',
                        uri: 'public://2019-08/test_stage_2_1.jpg',
                        url: '{STORYBOOK}/1140x450.png',
                        filemime: 'image/jpeg',
                        filesize: 85591,
                        status: true,
                        data: {
                            target_id: '17',
                            alt: 'stage 2',
                            title: 'stage 2',
                            width: '1140',
                            height: '450',
                        },
                        lang: 'de',
                        field_name: 'field_image_default',
                    },
                    data: {
                        target_id: '33',
                        target_revision_id: '1383',
                    },
                    lang: 'de',
                    field_name: 'field_group',
                },
                {
                    id: 36,
                    langcode: 'de',
                    type: 'image_simple',
                    status: true,
                    parent_field_name: 'field_group',
                    field_link: 'https://www.imwalking.de/sale/damenschuhe/sandalen-sandaletten/#highlight=701338,523266,593568,341563&lmPromo=la,2,hk,Startseite,fl,Startseite_Flagship3',
                    field_tracking: 'la,2,hk,Startseite,fl,Startseite_Flagship3',
                    field_type: 'media',
                    image_default: {
                        fid: 21,
                        langcode: 'de',
                        filename: 'test_stage_3_3.jpg',
                        uri: 'public://2019-08/test_stage_3_3.jpg',
                        url: '{STORYBOOK}/1140x450.png',
                        filemime: 'image/jpeg',
                        filesize: 70877,
                        status: true,
                        data: {
                            target_id: '21',
                            alt: 'stage 3',
                            title: 'stage 3',
                            width: '1140',
                            height: '450',
                        },
                        lang: 'de',
                        field_name: 'field_image_default',
                    },
                    data: {
                        target_id: '36',
                        target_revision_id: '729',
                    },
                    lang: 'de',
                    field_name: 'field_group',
                },
            ],
            field_type: 'slider',
            data: {
                target_id: '30',
                target_revision_id: '2448',
            },
            field_name: 'field_paragraph_iaw',
            field_valid_from: '2019-10-21T01:01:01+02:00',
        },
    ],
};
exports.cmsDataIncludingLinkData = {
    webapp_version: 1,
    revisionId: '2',
    menus: {
        custom: [],
        footer: [],
        main: [],
        service: [],
        shop: [],
        active: false,
    },
    alternateLinks: {
        de: 'http://emp-drupal.ddev.site:7080/de/node/1',
    },
    nid: 1,
    langcode: 'de',
    type: 'content',
    status: false,
    title: 'Testpage',
    promote: false,
    sticky: false,
    moderation_state: 'draft',
    path: [
        {
            alias: null,
            pid: null,
            langcode: 'de',
            lang: 'de',
            field_name: 'path',
        },
    ],
    paragraph: [
        {
            id: 6,
            langcode: 'de',
            type: 'group',
            status: true,
            parent_field_name: 'field_paragraphs',
            content_translation_changed: '2020-07-14T12:27:13+00:00',
            field_alignment: 'space-between',
            field_cells_per_row: 4,
            paragraph: [
                {
                    id: 7,
                    langcode: 'de',
                    type: 'html',
                    status: true,
                    parent_field_name: 'field_group',
                    content_translation_changed: '2020-07-14T12:03:44+00:00',
                    field_active_border: false,
                    field_distance: 'default',
                    field_margin: '4rem',
                    field_html_editor: "<p><strong>Linked Button</strong></p>\n            <table border=1 cellpadding=3>\n            <tr><td>Link</td><td>https://buttonlink.de/</td></tr>\n            <tr><td>Target</td><td>_blank</td></tr>\n            <tr><td>Tracking</td><td>la,1,tracking</td></tr>\n            <tr><td>Bonus-Number</td><td>123</td></tr>\n            <tr><td>Anchor</td><td>sprungziel</td></tr>\n            <tr><td>Highlight</td><td>1232456,564898987</td></tr>\n            <tr><td>Search-Filter</td><td>eyJmaWx0ZXJfbWFudWZhY3R1cmVyIjpbImZiX21uZmN0cnJfZGRzX2NkIl19</td></tr>\n            <tr><td>Store Link in Cookie</td><td>true</td></tr>\n            </table>",
                    field_text_align: 'left',
                    data: {
                        target_id: '7',
                        target_revision_id: '7',
                    },
                    field_name: 'field_group',
                },
                {
                    id: 1,
                    langcode: 'de',
                    type: 'link_by_button',
                    status: true,
                    parent_field_name: 'field_group',
                    content_translation_changed: '2020-07-09T15:34:42+00:00',
                    field_bonus_number: '123',
                    field_direction: 'right',
                    field_layout: 'base',
                    field_link: 'https://buttonlink.de/',
                    field_link_anchor: 'sprungziel',
                    field_link_highlight: '1232456,564898987',
                    field_link_searchfilter: 'eyJmaWx0ZXJfbWFudWZhY3R1cmVyIjpbImZiX21uZmN0cnJfZGRzX2NkIl19',
                    field_link_target: '_blank',
                    field_persist_target: true,
                    field_text: 'Buttontext',
                    field_tracking: 'la,1,tracking',
                    data: {
                        target_id: '1',
                        target_revision_id: '8',
                    },
                    field_name: 'field_group',
                },
                {
                    id: 8,
                    langcode: 'de',
                    type: 'html',
                    status: true,
                    parent_field_name: 'field_group',
                    content_translation_changed: '2020-07-14T12:03:44+00:00',
                    field_active_border: false,
                    field_distance: 'default',
                    field_margin: '4rem',
                    field_html_editor: "<p><strong>Linked Picture</strong></p>\n            <table border=1 cellpadding=3>\n              <tr><td>Link</td><td>https://imagelink.de/</td></tr>\n              <tr><td>Target</td><td>_self</td></tr>\n              <tr><td>Tracking</td><td>la,1,tracking</td></tr>\n              <tr><td>Bonus-Number</td><td>012354</td></tr>\n              <tr><td>Anchor</td><td>sprungziel</td></tr>\n              <tr><td>Highlight</td><td>6548945646</td></tr>\n              <tr><td>Search-Filter</td><td>eyJmaWx0ZXJfbWFudWZhY3R1cmVyIjpbImZiX21uZmN0cnJfZGRzX2NkIl19</td></tr>\n              <tr><td>Store Link in Cookie</td><td>true</td></tr></table>",
                    field_text_align: 'left',
                    data: {
                        target_id: '8',
                        target_revision_id: '9',
                    },
                    field_name: 'field_group',
                },
                {
                    id: 3,
                    langcode: 'de',
                    type: 'image_simple',
                    status: true,
                    parent_field_name: 'field_group',
                    content_translation_changed: '2020-07-09T15:34:42+00:00',
                    field_alternate_text: 'well',
                    field_bonus_number: '012354',
                    field_display_variant: 'default',
                    paragraph: [
                        {
                            id: 2,
                            langcode: 'de',
                            type: 'flexible_teaser',
                            status: true,
                            parent_field_name: 'field_image_paragraphs',
                            content_translation_changed: '2020-07-09T15:34:42+00:00',
                            field_bonus_number: '6489498',
                            field_font: 'default',
                            field_font_subheadline: 'default',
                            field_headline: 'FlexTeaser',
                            field_layout_variant: '3a',
                            field_link: 'https://flexibleteaserlink.de/',
                            field_link_anchor: 'sprungziel',
                            field_link_highlight: '56465456,89798798,6498498',
                            field_link_searchfilter: 'eyJmaWx0ZXJfbWFudWZhY3R1cmVyIjpbImZiX21uZmN0cnJfZGRzX2NkIl19',
                            field_link_target: '_self',
                            field_negative_text_color: false,
                            field_persist_target: true,
                            field_size: 'big',
                            field_size_subheadline: 'small',
                            field_tracking: 'la,1,flexTeaser',
                            field_vertical_alignment: 'center',
                            data: {
                                target_id: '2',
                                target_revision_id: '10',
                            },
                            field_name: 'field_image_paragraphs',
                        },
                    ],
                    field_image_size_type: 'max-width',
                    field_lazyload: false,
                    field_link: 'https://imagelink.de/',
                    field_link_anchor: 'sprungziel',
                    field_link_highlight: '6548945646',
                    field_link_searchfilter: 'eyJmaWx0ZXJfbWFudWZhY3R1cmVyIjpbImZiX21uZmN0cnJfZGRzX2NkIl19',
                    field_link_target: '_self',
                    field_persist_target: true,
                    field_title: 'well',
                    field_tracking: 'la,3,imagelink',
                    field_type: 'media',
                    field_valid_from: '2020-07-09T17:26:46+02:00',
                    image_default: {
                        fid: 1,
                        langcode: 'en',
                        filename: 'well_0_1.jpg',
                        uri: 'cloud-storage-develop-mg://2020-07/well_0_1.jpg',
                        url: '{STORYBOOK}/565x364.png',
                        filemime: 'image/jpeg',
                        filesize: 30296,
                        status: true,
                        data: {
                            target_id: '1',
                            alt: '',
                            title: '',
                            width: '570',
                            height: '402',
                        },
                        lang: 'de',
                        field_name: 'field_image_default',
                    },
                    data: {
                        target_id: '3',
                        target_revision_id: '11',
                    },
                    field_name: 'field_group',
                },
                {
                    id: 9,
                    langcode: 'de',
                    type: 'html',
                    status: true,
                    parent_field_name: 'field_group',
                    content_translation_changed: '2020-07-14T12:03:44+00:00',
                    field_active_border: false,
                    field_distance: 'default',
                    field_margin: '4rem',
                    field_html_editor: "<p>\n            <strong>Linked SVG-Graphic</strong></p>\n            <table border=1 cellpadding=3>\n            <tr><td>Link</td><td>https://svglink.de/</td></tr>\n            <tr><td>Target</td><td>_blank</td></tr>\n            <tr><td>Tracking</td><td>la,1,svglink</td></tr>\n            <tr><td>Bonus-Number</td><td>68945</td></tr>\n            <tr><td>Anchor</td><td>sprungziel</td></tr>\n            <tr><td>Highlight</td><td>64984984,56498797,65495646</td></tr>\n            <tr><td>Search-Filter</td><td>eyJmaWx0ZXJfbWFudWZhY3R1cmVyIjpbImZiX21uZmN0cnJfZGRzX2NkIl19</td></tr>\n            <tr><td>Store Link in Cookie</td><td>true</td></tr></table>",
                    field_text_align: 'left',
                    data: {
                        target_id: '9',
                        target_revision_id: '12',
                    },
                    field_name: 'field_group',
                },
                {
                    id: 4,
                    langcode: 'de',
                    type: 'svg_file',
                    status: true,
                    parent_field_name: 'field_group',
                    content_translation_changed: '2020-07-09T15:34:42+00:00',
                    field_bonus_number: '68945',
                    field_lazyload: false,
                    field_link: 'https://svglink.de/',
                    field_link_anchor: 'sprungziel',
                    field_link_highlight: '64984984,56498797,65495646',
                    field_link_searchfilter: 'eyJmaWx0ZXJfbWFudWZhY3R1cmVyIjpbImZiX21uZmN0cnJfZGRzX2NkIl19',
                    field_link_target: '_blank',
                    field_persist_target: true,
                    file: [
                        {
                            fid: 2,
                            langcode: 'en',
                            filename: 'svg-datei.svg',
                            uri: 'cloud-storage-production://2020-07/svg-datei.svg',
                            url: '{STORYBOOK}/565x364.png',
                            filemime: 'image/svg+xml',
                            filesize: 2145,
                            status: true,
                            data: {
                                target_id: '2',
                                display: '1',
                                description: '',
                            },
                            lang: 'de',
                            field_name: 'field_svg_file',
                        },
                    ],
                    field_tracking: 'la,1,svglink',
                    data: {
                        target_id: '4',
                        target_revision_id: '13',
                    },
                    field_name: 'field_group',
                },
                {
                    id: 10,
                    langcode: 'de',
                    type: 'html',
                    status: true,
                    parent_field_name: 'field_group',
                    content_translation_changed: '2020-07-14T12:03:44+00:00',
                    field_active_border: false,
                    field_distance: 'default',
                    field_margin: '4rem',
                    field_html_editor: "<p><strong>Linked Text</strong>\n            <table border=1 cellpadding=3>\n              <tr><td>Link</td><td>https://textlink.de/</td></tr>\n              <tr><td>Target</td><td>_blank</td></tr>\n              <tr><td>Tracking</td><td>la,1,textlink</td></tr>\n              <tr><td>Bonus-Number</td><td>6498498</td></tr>\n              <tr><td>Anchor</td><td>sprungziel</td></tr>\n              <tr><td>Highlight</td><td>9498494,5649849849</td></tr>\n              <tr><td>Search-Filter</td><td>eyJmaWx0ZXJfbWFudWZhY3R1cmVyIjpbImZiX21uZmN0cnJfZGRzX2NkIl19</td></tr>\n              <tr><td>Store Link in Cookie</td><td>true</td></tr>\n            </table></p>",
                    field_text_align: 'left',
                    data: {
                        target_id: '10',
                        target_revision_id: '14',
                    },
                    field_name: 'field_group',
                },
                {
                    id: 5,
                    langcode: 'de',
                    type: 'link_by_text',
                    status: true,
                    parent_field_name: 'field_group',
                    content_translation_changed: '2020-07-09T15:34:42+00:00',
                    field_bonus_number: '6498498',
                    field_link: 'https://textlink.de/',
                    field_link_anchor: 'sprungziel',
                    field_link_highlight: '9498494,5649849849',
                    field_link_searchfilter: 'eyJmaWx0ZXJfbWFudWZhY3R1cmVyIjpbImZiX21uZmN0cnJfZGRzX2NkIl19',
                    field_link_target: '_blank',
                    field_persist_target: true,
                    field_text: 'Linktext',
                    field_tracking: 'la,2,textlink',
                    data: {
                        target_id: '5',
                        target_revision_id: '15',
                    },
                    field_name: 'field_group',
                },
            ],
            field_type: 'group',
            field_valid_from: '2020-07-09T17:21:50+02:00',
            data: {
                target_id: '6',
                target_revision_id: '16',
            },
            field_name: 'field_paragraphs',
        },
    ],
};
//# sourceMappingURL=cmsdata.js.map